import { getMessages } from '../../../../../../store/constants';

export const AFFILIATE_TITLE = getMessages().getText('affiliate.title');
export const AFFILIATE_BODY = getMessages().getText('affiliate.body');
export const AFFILIATE_FAQ = getMessages().getText('affiliate.faq');
export const AFFILIATE_TRY_LATER = getMessages().getText('affiliate.try_later');
export const AFFILIATE_CLOSE = getMessages().getText('affiliate.close');

export const AFFILIATE_LINK = '/referral/';
